export type BrokerNerdsBarkerCoreEnumsMarketplace = (typeof BrokerNerdsBarkerCoreEnumsMarketplace)[keyof typeof BrokerNerdsBarkerCoreEnumsMarketplace];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsMarketplace = {
  Unknown: 'Unknown',
  SeatGeek: 'SeatGeek',
  StubHub: 'StubHub',
  TicketEvolution: 'TicketEvolution',
  TicketNetwork: 'TicketNetwork',
  VividSeats: 'VividSeats',
  Ticketmaster: 'Ticketmaster',
  Gametime: 'Gametime',
  TickPick: 'TickPick',
  GoTickets: 'GoTickets',
  Ticombo: 'Ticombo',
} as const;
